import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { BuyerAlerts } from '../../models/buyer-alerts.model';
import { Select, Store } from '@ngxs/store';
import { AnalyticsService } from 'smartauction-frontend-micro-library';
import {
  Configuration,
  ConfigurationState,
  Notification,
  NotificationRecipient,
  NotificationService,
  UserService
} from 'remarketing-angular-library';
import { BehaviorSubject, Observable, Subject, combineLatest } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import MicroModal from 'micromodal';
import { CheckUnsavedForms } from '../../interfaces/check-unsaved-forms';
import { TableColumn, TableRowSelectorDirective, LegacyTableModule } from 'remarketing-ui-components-lib';
import { NotificationsService } from '../../services/notifications/notifications.service';
import { Router } from '@angular/router';
import { get } from 'lodash';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { SaveChangesModalComponent } from '../save-changes-modal/save-changes-modal.component';
import { SuccessMessageComponent } from '../success-message/success-message.component';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { AlertTrackingConfig, AlertTrackingService } from '../../services/alert-tracking/alert-tracking.service';

// ATTN: This component is being used for bother buys and sellers
@Component({
    selector: 'app-alerts-buyers',
    templateUrl: './alerts-buyers.component.html',
    styleUrls: ['./alerts-buyers.component.scss'],
    providers: [{ provide: CheckUnsavedForms, useExisting: forwardRef(() => AlertsBuyersComponent) }],
    imports: [TranslocoDirective, LegacyTableModule, NgClass, ErrorMessageComponent, SuccessMessageComponent, SaveChangesModalComponent, AsyncPipe]
})
export class AlertsBuyersComponent implements OnInit, CheckUnsavedForms, OnDestroy {
  @Output() disableParentAccordion = new EventEmitter<boolean>();
  @Output() closeParentAccordion = new EventEmitter();
  @Select(ConfigurationState.configuration) private configuration$: Observable<Configuration>;
  tenantName$: Observable<string>;
  tenantUuid$: Observable<string>;
  tenantUuid: string;
  private cancelEditing$: Subject<boolean> = new Subject<boolean>();
  modalId = 'alerts-buyers__save-changes-modal';
  currentDrawer: TableRowSelectorDirective;
  editFlag = false;

  hoursOptions: any = [{ key: '1', value: 1 }, { key: '2', value: 2 }, { key: '3', value: 3 }];

  mockFormData: BuyerAlerts[] = [
    {
      label: 'Buyer Summary Report',
      value: false
    }
  ];

  mockForm = new BehaviorSubject(this.mockFormData);

  buyAlerts$: Observable<Array<Notification>>;
  sellAlerts$: Observable<Array<Notification>>;
  visibilityFlags: any = [];
  hasSellerEligibility: boolean;
  currentRecipient: NotificationRecipient;
  optedNotifications: Array<Notification>;
  optedNotificationsOriginal: Array<Notification>;
  showSuccess = false;
  showError = false;

  targetDrawer: TableRowSelectorDirective;
  targetRecipient: NotificationRecipient;
  openDrawerFlag = false;

  users$: Observable<Array<NotificationRecipient>>;

  private destroyed$ = new Subject();

  columns: TableColumn[] = [
    { key: 'name', label: '' },
    // { key: 'role', label: 'Role' },
    { key: 'email', label: '' },
    { key: 'phone', label: '' },
    { key: 'options', label: '' }
  ];

  cardConfig = {
    options: {
      fullWidth: true,
      showLabel: false
    }
  };

  @ViewChildren(TableRowSelectorDirective) drawers: QueryList<TableRowSelectorDirective>;

  @ViewChild('pageHeading') pageHeading: ElementRef;
  routerState;
  tenantShortName: string;
  notifications: Array<Notification>;

  constructor(
    private analyticsService: AnalyticsService,
    private notificationService: NotificationService,
    private notificationsService: NotificationsService,
    private alertTrackingService: AlertTrackingService,
    private readonly router: Router,
    private readonly _userService: UserService,
    private readonly store: Store,
    private readonly translocoService: TranslocoService
  ) {
    const currentNaviation = this.router.currentNavigation();

    if (currentNaviation && currentNaviation.extras && currentNaviation.extras.state) {
      this.routerState = currentNaviation.extras.state;
    }
  }

  get showSellerAlerts() {
    return this._userService.isSellerRole() && this.hasSellerEligibility;
  }

  ngOnInit() {
    this.getHeaderTranslations();
    this.buyAlerts$ = this.notificationsService.buyAlerts$.asObservable();
    this.sellAlerts$ = this.notificationsService.sellAlerts$.asObservable();
    this.notificationService.getNotifications().subscribe(notifications => {
      this.notifications = notifications;
      this.getTranslations();
    });

    this.tenantName$ = this.configuration$.pipe(map((configuration: Configuration) => configuration.tenantName));

    this.tenantUuid$ = this.configuration$.pipe(map((configuration: Configuration) => configuration.tenantUuid));

    this.tenantUuid$.pipe(takeUntil(this.destroyed$)).subscribe(tenantUuid => (this.tenantUuid = tenantUuid));
    this.analyticsService.trackPageLoad({
      page: {
        pageName: `${this.analyticsService.digitalData.page.category.site}:Profile Settings:Manage Alerts:Buyers`,
        section: 'Profile Settings',
        subsection: 'Manage Alerts',
        title: 'Buyers'
      }
    });

    this.notificationsService.visibilityFlags$.pipe(takeUntil(this.destroyed$)).subscribe(flags => {
      this.visibilityFlags = flags;
    });


    this.users$ = this.notificationsService.recipients$.asObservable();
    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(configuration => {
        this.tenantShortName = get(configuration, 'tenantShortName', null);
      });
    this.setUserSellerEligibility();
  }

  setUserSellerEligibility() {
    this.store
      .select(state => state.org.organization)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(organization => {
        this.hasSellerEligibility = organization?.organizationProfile.eligibleToSell;
      });
  }

  ngAfterViewInit(): void {
    if (this.routerState && this.routerState.focus) {
      this.pageHeading.nativeElement.focus();
    }
  }

  reformatPhone(phone) {
    phone = phone.replace(/-/g, '');
    if (phone.length > 0) {
      if (phone.length === 11) {
        phone = phone.slice(1, 4) + '-' + phone.slice(4, 7) + '-' + phone.slice(7);
        return phone;
      } else {
        phone = phone.slice(0, 3) + '-' + phone.slice(3, 6) + '-' + phone.slice(6);
        return phone;
      }
    }
  }

  toggleValue(index: number) {
    const currentState = this.mockForm.getValue();
    currentState[index].value = !currentState[index].value;
    this.mockForm.next(currentState);
  }

  /* istanbul ignore next */
  openCancelChangesModal(modalId: string) {
    MicroModal.show(modalId, {
      disableScroll: true
    });
    const heading = document.querySelector(`#${modalId} h1`) as HTMLElement;
    if (heading) {
      heading.focus();
    }
  }

  /* istanbul ignore next */
  closeModal(modalId: string) {
    MicroModal.close(modalId);
  }

  cancelEditing() {
    this.cancelEditing$.next(true);
    this.cancelEditing$.complete();
    this.closeParentAccordion.emit();
    this.focusElement('manage_' + this.currentRecipient.uuid + '_btn');
    this.setNotifications(this.optedNotificationsOriginal, this.currentRecipient);
    this.closeDrawer();
    if (this.openDrawerFlag) {
      this.openDrawer(this.targetDrawer, this.targetRecipient);
      this.openDrawerFlag = false;
    }
  }

  continueEditing() {
    this.cancelEditing$.next(false);
    this.cancelEditing$.complete();
    this.targetDrawer = null;
    this.targetRecipient = null;
    this.openDrawerFlag = false;
  }

  showNavigationAlert(): Observable<boolean> {
    this.openCancelChangesModal(this.modalId);
    this.cancelEditing$ = new Subject<boolean>();
    return this.cancelEditing$.asObservable();
  }

  hasUnsavedForms(): boolean {
    return this.editFlag === true;
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
    if (this.hasUnsavedForms()) {
      event.returnValue = true;
    }
  }

  openDrawer(drawer: TableRowSelectorDirective, recipient) {
    if (this.hasUnsavedForms()) {
      if (this.currentDrawer && this.currentDrawer !== drawer) {
        //Setting these variables incase a user wishes to continue navigation after cancelling saving changes
        this.targetDrawer = drawer;
        this.targetRecipient = recipient;
        this.openDrawerFlag = true;
      }
      this.openCancelChangesModal(this.modalId);
    } else {
      if (this.currentDrawer === drawer) {
        this.closeDrawer();
      } else if (this.currentDrawer && this.currentDrawer !== drawer) {
        this.closeDrawer();
        this.setOpenDrawerComponents(drawer, recipient);
      } else {
        this.setOpenDrawerComponents(drawer, recipient);
      }
    }
  }

  private setOpenDrawerComponents(drawer: TableRowSelectorDirective, recipient: any) {
    drawer.open();
    this.currentDrawer = drawer;
    this.currentRecipient = recipient;
    this.optedNotifications = recipient.optedNotifications || [];
    this.optedNotificationsOriginal = recipient.optedNotifications
      ? JSON.parse(JSON.stringify(recipient.optedNotifications))
      : [];
  }

  closeDrawer() {
    this.currentDrawer.close();
    this.currentDrawer = undefined;
    this.currentRecipient = undefined;
    this.editFlag = false;
    this.showError = false;
    this.showSuccess = false;
  }

  cancel() {
    if (this.currentDrawer) {
      if (this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal)) {
        this.openCancelChangesModal(this.modalId);
      } else {
        // focus on manage button
        this.focusElement('manage_' + this.currentRecipient.uuid + '_btn');
        this.closeDrawer();
      }
    }
  }

  save() {
    this.showError = false;
    this.showSuccess = false;
    const payload = {
      ...this.currentRecipient,
      optedNotifications: this.optedNotifications,
      tenantUuid: this.tenantUuid
    };

    this.notificationService
      .updateRecipient(this.currentRecipient.uuid, payload)
      .pipe(take(1))
      .subscribe(
        recipient => {
          this.currentRecipient = recipient;
          this.optedNotifications = recipient.optedNotifications;
          this.optedNotificationsOriginal = JSON.parse(JSON.stringify(recipient.optedNotifications));
          this.showSuccess = true;
          this.trackAlerts(true);
          // focus on buyer name cell
          this.focusElement('name_' + recipient.uuid + '_cell');
          this.editFlag = false;
        },
        () => {
          this.trackAlerts(false);
          this.showError = true;
        }
      );
  }

  showAlert() {
    // do whatever action is expected when you are moving away from unsaved changes
    this.showNavigationAlert();
  }

  mapAlertTranslations(alerts: Observable<Array<Notification>>) {
    alerts.pipe(takeUntil(this.destroyed$)).subscribe(values => {
      values.forEach(value => {
        value['descriptionCode'] = this.notifications.find(n => n.type === value.type).description;
      });
    });
  }

  getAlertDescription(alert: Notification): string {
    return this.translocoService.translateObject('notifications.' + alert.type);
  }

  checkVisibility(alert) {
    for (const key in this.visibilityFlags) {
      if (
        alert &&
        alert.descriptionCode &&
        key.toLowerCase() === alert.descriptionCode?.toLowerCase() && alert.sendType === 'Email') {
        return this.visibilityFlags[key].visible;
      }
    }
  }

  updateNotification(e, notification) {
    if (e.target.checked) {
      this.optedNotifications.push(notification);
    } else {
      const i = this.optedNotifications.findIndex(n => n.type === notification.type);
      this.optedNotifications.splice(i, 1);
    }

    if (this.areNotEqual(this.optedNotifications, this.optedNotificationsOriginal)) {
      this.editFlag = true;
    } else {
      this.editFlag = false;
    }
  }

  checked(type) {
    if (this.optedNotifications) {
      return this.optedNotifications.find(n => n.type === type);
    }
    return false;
  }

  areNotEqual(array, ogArray, category?) {
    let arr1;
    let arr2;
    if (category) {
      arr1 = array
        .concat()
        .filter(n => n.category === category)
        .sort();
      arr2 = ogArray
        .concat()
        .filter(n => n.category === category)
        .sort();
    } else {
      arr1 = array.concat().sort((a, b) => a.type.localeCompare(b.type));
      arr2 = ogArray.concat().sort((a, b) => a.type.localeCompare(b.type));
    }

    if (arr1.length !== arr2.length) return true;

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].type !== arr2[i].type) {
        return true;
      }
    }

    return false;
  }

  private trackAlerts(isSuccess: boolean){
    combineLatest([
      this.buyAlerts$.pipe(take(1)),
      this.sellAlerts$.pipe(take(1))
    ]).subscribe(([buyAlerts,sellAlerts]) =>  {
      const config = this.alertTrackingService.createConfigForBuyersAndOtherRecipients(
        'Buyer Alerts',
        buyAlerts,
        sellAlerts,
        this.showSellerAlerts,
        alert => this.checkVisibility(alert),
        alert => this.getAlertDescription(alert),
        type => !!this.checked(type)
      );
      this.alertTrackingService.trackAlertPreferences(config,isSuccess);
    }
    );
  }

  setNotifications(notifications, recipient) {
    const recipients = this.notificationsService.recipients$.getValue();
    const index = recipients.findIndex(r => r.uuid === recipient.uuid);
    recipient.optedNotifications = JSON.parse(JSON.stringify(notifications));
    recipients.splice(index, 1, recipient);
    this.notificationsService.recipients$.next(recipients);
  }

  focusElement(id) {
    setTimeout(() => {
      const element = document.getElementById(id) as HTMLElement;
      if (element) {
        element.focus();
      }
    }, 0);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getHeaderTranslations(){
    this.translocoService.selectTranslateObject('profileManagement.alertBuyers.tableHeader').pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.columns[0].label = translate.labelName;
      this.columns[1].label = translate.labelEmail;
      this.columns[2].label = translate.labelPhone;
      this.columns[3].label = translate.labelOption;
    });
  }

  getTranslations(){
    this.translocoService.selectTranslateObject('profileManagement.alertBuyers.tableHeader').pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.mapAlertTranslations(this.buyAlerts$);
      this.mapAlertTranslations(this.sellAlerts$);
    });
  }
}
